<template>
  <div>
    <transition v-if="onload" name="fade">
      <LoadingMask />
    </transition>
    <div v-else class="c-app">
      <TheSidebar />
      <div class="c-wrapper">
        <TheHeader />
        <div :class="[ 'c-body', { 'p-0': noPadding }]">
          <main :class="['c-main', { 'p-0': noPadding }]">
            <CContainer fluid :class="{'p-0': noPadding }">
              <b-overlay opacity="0.75" variant="light" :show="mainLoading">
                <router-view :key="$route.fullPath" />
              </b-overlay>
            </CContainer>
          </main>
        </div>
        <TheFooter />
      </div>
    </div>
    <GlobalModalAlert />
    <GlobalModalAlertError />
  </div>
</template>

<script>
import TheSidebar from "./TheSidebar";
import TheHeader from "./TheHeader";
import TheFooter from "./TheFooter";
import { mapGetters } from "vuex";
import LoadingMask from "@/views/pages/LoadData";
import GlobalModalAlert from "@/components/modal/alert/global/ModalAlert";
import GlobalModalAlertError from "@/components/modal/alert/global/ModalAlertError";

export default {
  name: "TheContainer",
  components: {
    TheSidebar,
    TheHeader,
    TheFooter,
    LoadingMask,
    GlobalModalAlert,
    GlobalModalAlertError
  },
  computed: {
    ...mapGetters(["isLoading", "getBrandDetail"]),
    ...mapGetters({ mainLoading: 'getMainLoading' }),
  },
  data() {
    return {
      onload: true,
      noPadding: false,
    }
  },
  watch: {
    "$route.fullPath": function () {
      this.checkRouter();
    },
  },
  methods: {
    checkRouter() {
      var routePrevent = ["FLOW BUILDER"];
      if (routePrevent.includes(this.$route.name)) {
        this.noPadding = true;
      } else {
        this.noPadding = false;
      }
    },
    getDataProfile: function () {
      var admin_token = this.$cookies.get("admin-token");
      if (admin_token) {
        this.axios.get(`${this.$baseUrl}/user`).then((res) => {
          res.detail.token = admin_token;
          this.$store.dispatch("setUserData", res.detail);
        });
        this.getBrandList();
      }
      this.setTimeStapm();
    },
    getBrandList: function () {
      var admin_brand_id = this.$route.query.brandID;
      this.axios.get(`${this.$baseUrl}/brand/list`).then((res) => {
        if (res.result) {
          this.$store.dispatch("setBrandList", res.detail);
          if (!admin_brand_id) {
            this.$store.dispatch(
              "setCurrentBrandID",
              this.$store.getters.getBrandList()[0].id
            );
            this.$router.replace({
              name: "FLOW BUILDER",
              query: { brandID: this.$store.getters.getBrandList()[0].id },
            });
          } else {
            let brandPermission = this.$store.getters
              .getBrandList()
              .find((el) => el.id == admin_brand_id);
            if (brandPermission) {
              this.$store.dispatch("setCurrentBrandID", admin_brand_id);
            } else {
              this.$store.dispatch(
                "setCurrentBrandID",
                this.$store.getters.getBrandList()[0].id
              );
              this.$router.replace({
                name: "FLOW BUILDER",
                query: { brandID: this.$store.getters.getBrandList()[0].id },
              });
            }
          }
        }
      });
    },
    setTimeStapm() {
      this.$store.watch(
        (state) => {
          return this.isLoading();
        },
        (val) => {
          if (!this.isLoading()) {
            setTimeout(() => {
              this.onload = false;
            }, 1000);
          }
        },
        {
          deep: true,
        }
      );
    },
  },
  created: function () {
    this.getDataProfile();
    this.checkRouter();
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
